import {useEffect, useMemo, useRef, useState} from "react";
import {css} from "@emotion/react";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {object} from "yup";

import {Button} from "@pg-design/button-module";
import {gap, mt} from "@pg-design/helpers-css-strings";
import {FormProviderRHF, InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {Highlight, Text} from "@pg-design/text-module";
import {hitGtmUserPhoneNumber} from "@pg-mono/google-tag-manager/src/gtm_user_phone_number";
import {useFormRHF} from "@pg-mono/react-hook-forms-utils";

import {useUserUpdatePhoneNumberModalContext} from "../context/UserUpdatePhoneNumberModalContext";

export interface IUserUpdatePhoneNumberFormProps {
    isOpen: boolean;
    onSuccess?: () => void;
}

interface IFormData {
    name: string;
    phone: {
        code: string | number;
        number: string;
    };
}

export const UserUpdatePhoneNumberForm = (props: IUserUpdatePhoneNumberFormProps) => {
    const {isOpen, onSuccess} = props;
    const context = useUserUpdatePhoneNumberModalContext();
    const [userInfo, setUserInfo] = useState<Awaited<ReturnType<typeof context.getUserProfile>>>(null);

    const formDirtyRef = useRef<boolean>(false);
    const formTouchedRef = useRef<boolean>(false);

    useEffect(() => {
        if (isOpen) {
            context.getUserProfile().then((profile) => {
                setUserInfo(profile);
            });
        }
    }, [isOpen, context]);

    const validationSchema = object().shape({
        name: Yup.string().required(context.getValidationMessage("required")),
        phone: object().shape({
            code: Yup.mixed<string | number>().required(),
            number: Yup.string()
                .required("Podaj numer telefonu")
                .matches(/^\d+$/, "Podaj poprawny numer telefonu")
                .min(9, "Numer telefonu musi mieć 9 cyfr")
                .max(9, "Numer telefonu musi mieć 9 cyfr")
        })
    });

    useEffect(() => {
        if (isOpen) {
            hitGtmUserPhoneNumber("view");
        }
    }, [isOpen]);

    const countryCodes = context.getCountryCodes();
    const userFirstName = userInfo?.name?.split(" ")[0];
    const phoneParts = userInfo?.phone?.split(" ") ?? [];

    const defaultValues = useMemo<IFormData>(() => {
        return {
            name: userInfo?.name ?? "",
            phone: {
                code: context.defaultCountryCode,
                number: phoneParts[1] ?? ""
            }
        };
    }, [userInfo]);

    const form = useFormRHF<IFormData>({
        resolver: yupResolver(validationSchema),
        mode: "onBlur",
        defaultValues
    });

    useEffect(() => {
        if (userInfo) {
            form.reset(defaultValues);
        }
    }, [userInfo, form, defaultValues]);

    useEffect(() => {
        if (form.formState.isDirty && !formDirtyRef.current) {
            formDirtyRef.current = true;
            hitGtmUserPhoneNumber("fill");
        }
    }, [form.formState.isDirty, context]);

    const onFormClick = () => {
        if (!formTouchedRef.current) {
            formTouchedRef.current = true;
            hitGtmUserPhoneNumber("click");
        }
    };

    const onSubmit = async (values: IFormData) => {
        const response = await context.updateUserProfile({
            name: values.name,
            phone: values.phone ? `${values.phone.code} ${values.phone.number}` : ""
        });

        hitGtmUserPhoneNumber("submit");

        if (response.error) {
            const {error} = response;

            if (error.data) {
                for (const field of Object.keys(error.data)) {
                    const message = error.data[field];
                    const errorMessage = Array.isArray(message) ? message.join(", ") : message;

                    if (field === "phone") {
                        form.setError("phone.number", {type: "server", message: errorMessage});
                        continue;
                    }

                    form.setError(field as keyof IFormData, {type: "server", message: errorMessage});
                }
            } else {
                context.onError({message: "Wystąpił błąd podczas aktualizacji danych"});
            }
        } else {
            onSuccess?.();
        }
    };

    const {isSubmitting} = form.formState;

    if (!userInfo) {
        return null;
    }

    return (
        <>
            <Text variant="headline_3" align="left" mb={0.5}>
                Witaj{" "}
                {userInfo.name && (
                    <Highlight>
                        <span css={boldTextStyle}>{userFirstName}</span>
                    </Highlight>
                )}
            </Text>

            <Text variant="body_copy_2" mb={3}>
                Uzupełnij swoje dane, aby odkryć wszystkie ceny.
            </Text>

            <FormProviderRHF {...form}>
                <form css={formStyle} onSubmit={form.handleSubmit(onSubmit)}>
                    <div css={formStyle} onClick={onFormClick}>
                        <InputField name="name" placeholder="Imię i nazwisko" disabled={!!userInfo.name} />
                        <PhoneFieldControlled name="phone" codes={countryCodes} placeholder="Telefon" maxMenuHeight={150} />
                    </div>

                    <Button variant="filled_primary" type="submit" fullWidth css={buttonStyle} isLoading={isSubmitting} disabled={isSubmitting}>
                        POTWIERDŹ DANE
                    </Button>
                </form>
            </FormProviderRHF>
        </>
    );
};

const formStyle = css`
    display: flex;
    flex-direction: column;
    ${gap(1)};
`;

const buttonStyle = css`
    ${mt(2)};
`;

const boldTextStyle = css`
    font-weight: 700;
`;
import {useEffect, useMemo, useRef, useState} from "react";
import {css} from "@emotion/react";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {object} from "yup";

import {Button} from "@pg-design/button-module";
import {gap, mt} from "@pg-design/helpers-css-strings";
import {FormProviderRHF, InputField, PhoneFieldControlled} from "@pg-design/rhf-components-module";
import {Highlight, Text} from "@pg-design/text-module";
import {hitGtmUserPhoneNumber} from "@pg-mono/google-tag-manager/src/gtm_user_phone_number";
import {useFormRHF} from "@pg-mono/react-hook-forms-utils";

import {useUserUpdatePhoneNumberModalContext} from "../context/UserUpdatePhoneNumberModalContext";

export interface IUserUpdatePhoneNumberFormProps {
    isOpen: boolean;
    onSuccess?: () => void;
}

interface IFormData {
    name: string;
    phone: {
        code: string | number;
        number: string;
    };
}

export const UserUpdatePhoneNumberForm = (props: IUserUpdatePhoneNumberFormProps) => {
    const {isOpen, onSuccess} = props;
    const context = useUserUpdatePhoneNumberModalContext();
    const [userInfo, setUserInfo] = useState<Awaited<ReturnType<typeof context.getUserProfile>>>(null);

    const formDirtyRef = useRef<boolean>(false);
    const formTouchedRef = useRef<boolean>(false);

    useEffect(() => {
        if (isOpen) {
            context.getUserProfile().then((profile) => {
                setUserInfo(profile);
            });
        }
    }, [isOpen, context]);

    const validationSchema = object().shape({
        name: Yup.string().required(context.getValidationMessage("required")),
        phone: object().shape({
            code: Yup.mixed<string | number>().required(),
            number: Yup.string()
                .required("Podaj numer telefonu")
                .matches(/^\d+$/, "Podaj poprawny numer telefonu")
                .min(9, "Numer telefonu musi mieć 9 cyfr")
                .max(9, "Numer telefonu musi mieć 9 cyfr")
        })
    });

    useEffect(() => {
        if (isOpen) {
            hitGtmUserPhoneNumber("view");
        }
    }, [isOpen]);

    const countryCodes = context.getCountryCodes();
    const userFirstName = userInfo?.name?.split(" ")[0];
    const phoneParts = userInfo?.phone?.split(" ") ?? [];

    const defaultValues = useMemo<IFormData>(() => {
        return {
            name: userInfo?.name ?? "",
            phone: {
                code: context.defaultCountryCode,
                number: phoneParts[1] ?? ""
            }
        };
    }, [userInfo]);

    const form = useFormRHF<IFormData>({
        resolver: yupResolver(validationSchema),
        mode: "onBlur",
        defaultValues
    });

    useEffect(() => {
        if (userInfo) {
            form.reset(defaultValues);
        }
    }, [userInfo, form, defaultValues]);

    useEffect(() => {
        if (form.formState.isDirty && !formDirtyRef.current) {
            formDirtyRef.current = true;
            hitGtmUserPhoneNumber("fill");
        }
    }, [form.formState.isDirty, context]);

    const onFormClick = () => {
        if (!formTouchedRef.current) {
            formTouchedRef.current = true;
            hitGtmUserPhoneNumber("click");
        }
    };

    const onSubmit = async (values: IFormData) => {
        const response = await context.updateUserProfile({
            name: values.name,
            phone: values.phone ? `${values.phone.code} ${values.phone.number}` : ""
        });

        hitGtmUserPhoneNumber("submit");

        if (response.error) {
            const {error} = response;

            if (error.data) {
                for (const field of Object.keys(error.data)) {
                    const message = error.data[field];
                    const errorMessage = Array.isArray(message) ? message.join(", ") : message;

                    if (field === "phone") {
                        form.setError("phone.number", {type: "server", message: errorMessage});
                        continue;
                    }

                    form.setError(field as keyof IFormData, {type: "server", message: errorMessage});
                }
            } else {
                context.onError({message: "Wystąpił błąd podczas aktualizacji danych"});
            }
        } else {
            onSuccess?.();
        }
    };

    const {isSubmitting} = form.formState;

    if (!userInfo) {
        return null;
    }

    return (
        <>
            <Text variant="headline_3" align="left" mb={0.5}>
                Witaj{" "}
                {userInfo.name && (
                    <Highlight>
                        <span css={boldTextStyle}>{userFirstName}</span>
                    </Highlight>
                )}
            </Text>

            <Text variant="body_copy_2" mb={3}>
                Uzupełnij swoje dane, aby odkryć wszystkie ceny.
            </Text>

            <FormProviderRHF {...form}>
                <form css={formStyle} onSubmit={form.handleSubmit(onSubmit)}>
                    <div css={formStyle} onClick={onFormClick}>
                        <InputField name="name" placeholder="Imię i nazwisko" disabled={!!userInfo.name} />
                        <PhoneFieldControlled name="phone" codes={countryCodes} placeholder="Telefon" maxMenuHeight={150} />
                    </div>

                    <Button variant="filled_primary" type="submit" fullWidth css={buttonStyle} isLoading={isSubmitting} disabled={isSubmitting}>
                        POTWIERDŹ DANE
                    </Button>
                </form>
            </FormProviderRHF>
        </>
    );
};

const formStyle = css`
    display: flex;
    flex-direction: column;
    ${gap(1)};
`;

const buttonStyle = css`
    ${mt(2)};
`;

const boldTextStyle = css`
    font-weight: 700;
`;
